export const WIX_PAY_SUCCESSFUL_STATUS = ['Pending', 'Successful', 'Offline']

export const CreateBookingStatus = {
	APPROVED: 'APPROVED',
	PENDING_WIX_PAY_APPROVAL: 'PENDING_WIX_PAY_APPROVAL',
	PENDING_APPROVAL: 'PENDING_APPROVAL',
}

export const CheckoutBookingStatus = {
	CONFIRMED: 'Confirmed',
	TERMINATED: 'Terminated',
	PENDING_APPROVAL: 'Pending Approval',
}

export const ValidationErrorCodes = {
	MISSING_FIELD: -10004,
	OVER_CAPACITY: -10011,
}
